import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserResponse } from 'algorilla-shared-libs';
import { HeaderComponent } from 'src/app/header/header.component';
import { ManagementService } from 'src/app/services/management.service';
import { BowmanCacheService } from 'bowman-cache';
import { BowmanLogger, BowmanLoggerService } from 'bowman-logger';
import { Observable, Subscription, timer } from 'rxjs';
import { SecurityService } from 'src/services/security.service';
import { CustomizationService } from '../../services/customization-service';
import { CustomizationConfiguration } from './../../services/model/customization-configuration';
import { environment } from 'src/environments/environment';


@Component({
     selector: 'app-authorization',
     templateUrl: './authorization.component.html',
     styleUrls: ['./authorization.component.scss'],
     providers: [SecurityService],
     changeDetection: ChangeDetectionStrategy.OnPush,

})
export class AuthorizationComponent implements OnInit {
     private log: BowmanLogger = new BowmanLogger(this._loggerService, 'AuthorizationComponent');
     user: UserResponse;
     public username: string;
     public password: string;
     public message: string;
     isLoading: boolean = false;
     private _authenticationSubscription: Subscription;
     private _authenticationTimer: Observable<number>;
     public serverVersion: string;
     public frontendVersion: string;
     public currentYear: string = new Date().getFullYear().toString();
     public appInitialized: boolean = false;
     public customization: CustomizationConfiguration = null;
     public alternativeLoginMethods: any[] = [];

     constructor(
          private _securityService: SecurityService,
          private _loggerService: BowmanLoggerService,
          private _bowmanCacheService: BowmanCacheService,
          private _managementService: ManagementService,
          private _customizationService: CustomizationService,
          private _cdr: ChangeDetectorRef,
          private _router: Router
     ) {
          this.frontendVersion = environment.version;

     }


     submitLogin(username: string, password: string) {
          this.isLoading = true;
          this._cdr.detectChanges();
          this._securityService.authenticate(username, password).subscribe(res => {
               if (res.status === 'OK' && res.result.name) {
                    this.log.info("Authenticated as " + username + ": ", res);
                    this.user = res.result;
                    this.user.options = HeaderComponent.setDisplayTimezone(this.user.options);
                    this._bowmanCacheService.set('algorilla_user', this.user, 604800000);
                    //        this._router.navigate(['discovery']);
               } else {
                    this.log.error("Cannot authenticate: ", res.message);
                    this.message = res.message;
               }
               this.isLoading = false;
               this._cdr.detectChanges();
          }, err => {
               this.log.error("Cannot authenticate: ", err);
               this.message = err;
               this.isLoading = false;
               this._cdr.detectChanges();
          })
     }




     ngOnInit() {
          this.message = null;
          this.getCustomizations();
          this._managementService.getServerVersion().subscribe(res => {
               this._managementService.getApplicationConfigurations().subscribe(appConfigurationsRes => {
                    if (appConfigurationsRes && Object.keys(appConfigurationsRes).length > 0) {
                         Object.keys(appConfigurationsRes).map(appConfigurationKey => {
                              try {
                                   let appConfiguration = JSON.parse(appConfigurationsRes[appConfigurationKey]);
                                   this.alternativeLoginMethods.push(appConfiguration);
                              } catch (appConfigurationParseException) {
                                   this.log.error(`Unable to parse '${appConfigurationKey}' configuration: ${appConfigurationParseException}`);
                              }
                         })
                    }
                    this._cdr.detectChanges();


               }, err => {
                    this.log.error("Unable to get server version", err);
                    this._cdr.detectChanges();
               });
               this.serverVersion = res;

                    this._securityService.isAuthenticated().subscribe(response => {
                         this.appInitialized = true;
                         if (response.status == 'OK') {
                              this.log.debug("User is authenticated");
                              this.user = response.result;
                              this.user.options = HeaderComponent.setDisplayTimezone(this.user.options);
                              this._bowmanCacheService.set('algorilla_user', this.user, 604800000);
                              // Start timer. Check every 5 minutes if the user is authenticated.
                              this._authenticationTimer = timer(0, (30 * 1000) * 1);
                              this._authenticationSubscription = this._authenticationTimer.subscribe(() => {
                                   this._securityService.isAuthenticated().subscribe(response => {
                                        if (response.status == 'OK') {
                                             this.user = response.result;
                                             this.user.options = HeaderComponent.setDisplayTimezone(this.user.options);
                                             this._bowmanCacheService.set('algorilla_user', this.user, 604800000);

                                        } else {
                                             this.log.warn("User is not authenticated");
                                             this.user = null;
                                             this._bowmanCacheService.set('algorilla_user', null);
                                             this._authenticationSubscription.unsubscribe();
                                             window.location.reload();
                                        }
                                        this._cdr.detectChanges();
                                   }, err => {
                                        this.log.warn("Server error.");
                                        this.user = null;
                                        this._bowmanCacheService.set('algorilla_user', null);
                                        this._authenticationSubscription.unsubscribe();
                                        window.location.reload();
                                   });
                              });
                         } else {
                              this.log.info("User is not authenticated");
                              this.user = null;
                              this._cdr.detectChanges();
                         }
                    }, err => {
                         this.log.error("Cannot check if user is authenticated.");
                         this.user = null;
                         this._cdr.detectChanges();
                    })
          });

     }
     private getCustomizations() {
          this._customizationService.getCustomization().subscribe((res) => {
               this.customization = res;
          });
     }
}

